import { Reveal } from "./shared";

const PILLARS = [
  {
    badge: "01 / PREDICTIVE",
    title: "30+ Behavioral Velocity Signals",
    desc: "Monitors order-level fluctuations, customer feedback nuances, and carrier handoffs 24/7 — before they breach Amazon's visible KPI thresholds.",
  },
  {
    badge: "02 / ZERO INTRUSION",
    title: "Read-Only Amazon SP-API",
    desc: "Connects in 60 seconds with strict read-only permissions. Zero write access, zero security liability — certified Amazon Software Partner architecture.",
  },
  {
    badge: "03 / FORENSIC ACTION",
    title: "Automated Remediation Protocols",
    desc: "Generates verified Plan of Action frameworks and root-cause teardowns backed by former Amazon policy specialists — before accounts receive notices.",
  },
];

export const Solution = () => (
  <section data-testid="solution-section" className="bg-white border-y border-slate-200 py-20 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-indigo-700">
          The Protego AI engine
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-4 max-w-3xl">
          Continuous account health surveillance for high-stakes operators
        </h2>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-3 gap-5">
        {PILLARS.map((p, i) => (
          <Reveal key={p.badge} delay={i * 0.08} className="h-full">
            <div
              data-testid={`pillar-${i + 1}`}
              className="h-full bg-slate-50 rounded-2xl border border-slate-200 border-t-2 border-t-indigo-500 p-8"
            >
              <span className="font-mono text-[11px] font-semibold tracking-widest text-indigo-700">
                {p.badge}
              </span>
              <h3 className="font-display font-bold text-xl text-slate-900 mt-4">{p.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed mt-3">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
